export class AtividadeUpdateConcluida {
    id: number;
    concluida: boolean;

    constructor(id: number, concluida: boolean) {
        this.id = id;
        this.concluida = concluida;
    }
}
